import { gql, useMutation } from "@apollo/client";

export type UpdatePasswordInput = {
    token: string;
    newPassword: string;
};

const UPDATE_PASSWORD = gql(`
  mutation UserResetPassword($input: GqlUserResetPasswordInput!) {
    userResetPassword(input: $input)
  }
`);

export default function useUpdatePassword() {
    const [updatePassword, { data, loading, error }] = useMutation(UPDATE_PASSWORD);

    return {
        updatePassword: (data: UpdatePasswordInput) =>
            updatePassword({
                variables: {
                    input: data,
                },
            }),
        loading,
        error,
        data: data?.userUpdatePassword,
    };
}
